import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { ClientOnly } from '@tanstack/react-router'
import { ComponentDemos } from './-components/dev-resources/component-demos'
import { EmailGallery, EmailGalleryBoundary, EmailGallerySkeleton } from './-components/dev-resources/email-gallery'
import { PanelBlockPending } from './-components/app-layout-skeleton'

export const Route = createFileRoute('/_app/dev-resources/')({
  component: RouteComponent,
  pendingComponent: PanelBlockPending,
})

function RouteComponent() {
  return (
    <div data-dev-scroll className="relative h-full overflow-y-auto px-6 pb-6 sm:px-8 sm:pb-8">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 pt-6 sm:pt-8">
        <header className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold">Developer resources</h1>
          <p className="text-muted-foreground text-sm">
            Internal dev playground — preview email templates and UI components in one place. The email rendering here
            is the exact output that gets sent, and is snapshotted in{' '}
            <code className="text-xs">catalog.unit.test.ts</code> (a unit test fails if a template changes unexpectedly;
            run <code className="text-xs">pnpm test -u</code> to accept changes).
          </p>
        </header>

        <section className="flex flex-col gap-4">
          <h2 className="text-xl font-semibold">Email templates</h2>
          {/* Super-admin-gated data → resolved with useSuspenseQuery inside the gallery. ClientOnly keeps the
              admin fetch off the SSR path; the boundary turns a non-admin's NOT_LOGGED_IN into a message. */}
          <EmailGalleryBoundary>
            <ClientOnly fallback={<EmailGallerySkeleton />}>
              <Suspense fallback={<EmailGallerySkeleton />}>
                <EmailGallery />
              </Suspense>
            </ClientOnly>
          </EmailGalleryBoundary>
        </section>

        <section id="components" className="flex scroll-mt-4 flex-col gap-6 border-t pt-10">
          <h2 className="text-xl font-semibold">Component demos</h2>
          <ComponentDemos />
        </section>
      </div>
    </div>
  )
}
